import React from "react";
import './App.scss';

import { Provider } from 'react-redux'
import { configureStore2 } from './store/index'
import { AppRouter } from './router';
import { NotificationLayer } from './notification';

export default function App() {
  return (
    <Provider store={configureStore2({})}>
      <NotificationLayer>
        <AppRouter />
      </NotificationLayer>
    </Provider >
  );
}
